import React, { useState, useEffect, useRef } from 'react'
import Popup from 'reactjs-popup'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import { useSelector } from 'react-redux'

export default function PlainFileNavigationPopup({ isOpen, file, closeModal }) {
  const navContainer = useRef()

  const {
    common: { isNative, isMobile, isTablet }
  } = useSelector((state) => state)

  const isMobileDevice = isNative || isMobile || isTablet

  useEffect(() => {
    if (navContainer) {
      navContainer.current.focus()
    }
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  return file ? (
    <Popup
      lockScroll
      nested
      contentStyle={{
        background: 'transparent',
        border: '0',
        width: '100vw',
        height: '100vh'
      }}
      overlayStyle={{
        background: isMobileDevice ? 'rgba(46, 45, 45, 0.8)' : 'rgba(46, 45, 45, 0.3)',
        backdropFilter: 'blur(4px)'
      }}
      open={isOpen}
      onClose={closeModal}>
      <div className={styles.container}>
        <div ref={navContainer} className={`${styles.main} `} tabIndex={-1}>
          <div className={`${styles.mainInner1} `}>
            <div className={styles.leftActions}>
              <div role='button' className={`${styles.navigationButton} ${styles.closeButton} `} onClick={closeModal}>
                <Icon name='close24' size='large24' styleModifier={styles.navigationIcon} />
                {/* {isMobileDevice ? (
                  <Icon name='arrow-left24' size='large24' />
                ) : (
                  <Icon name='close24' size='large24' styleModifier={styles.navigationIcon} />
                )} */}
              </div>
            </div>
          </div>

          <div className={`${styles.mainInner2}`}>
            <img className={`${styles.image}`} src={file} />
          </div>
        </div>
      </div>
    </Popup>
  ) : null
}
